(function iframes($, Drupal, once) {
  Drupal.behaviors.rutherfordIframes = {
    attach(context) {
      $(once('rutherford-iframes', '.iframe__iframe iframe', context))
        .each(function eachIframe() {
          // Not working? Try a different height calculation method.
          // https://github.com/davidjbradshaw/iframe-resizer/blob/master/docs/parent_page/options.md#heightcalculationmethod
          $(this).iFrameResize({
            warningTimeout: 0,
            scrolling: 'omit',
          });

          // The below functions attempt to scroll to the top of the iframe each
          // time it reloads. This is useful when a user has done something like
          // submit a long form. If we didn't scroll to the top of the iframe
          // then they would be likely to miss the confirmation message or any
          // error messages.
          function scrollIframeIntoView() {
            const headerHeight =
              parseInt(
                getComputedStyle(document.documentElement).getPropertyValue(
                  '--site-header-height',
                ),
                10,
              ) || 0;

            // Only scroll if the iframe is taller than the viewport minus the
            // sticky header.

            const iframeHeight = parseInt(this.height, 10);
            const availableVerticalSpace =
              (window.innerHeight || document.documentElement.clientHeight) -
              headerHeight;

            if (iframeHeight > availableVerticalSpace) {
              this.scrollIntoView();
            }
          }

          function addEventListenerOnlyAfterInitialLoad() {
            // Add the event listener that will scroll the iframe the next time
            // it reloads.
            this.addEventListener('load', scrollIframeIntoView);
            // Then remove the event listener that calls this function as we only
            // want it to run once on the initial iframe load, not on each subsequent
            // load.
            this.removeEventListener(
              'load',
              addEventListenerOnlyAfterInitialLoad,
            );
          }

          $(this)[0].addEventListener(
            'load',
            addEventListenerOnlyAfterInitialLoad,
          );
        });
    },
  };
})(jQuery, Drupal, once);
